import { render, staticRenderFns } from "./cash2.vue?vue&type=template&id=18276cef&scoped=true&"
import script from "./cash2.vue?vue&type=script&lang=js&"
export * from "./cash2.vue?vue&type=script&lang=js&"
import style0 from "./cash2.vue?vue&type=style&index=0&id=18276cef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18276cef",
  null
  
)

export default component.exports